import {HttpInterceptorFn} from '@angular/common/http';
import {IGNORE_ERROR} from '../utils/constants/context';
import {AuthService} from '../services/auth.service';
import {inject} from '@angular/core';
import {catchError, throwError} from 'rxjs';
import {ToastService} from '../services/toast.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(IGNORE_ERROR)) return next(req);

  const authService = inject(AuthService);
  const toastService = inject(ToastService);

  return next(req).pipe(
    catchError((error) => {
      console.log(error);
      toastService.showToastError(
        error.error?.Errors[0] ||
          `Error ${error.status} ${codeMessage(error.status)}`
      );
      if (error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    })
  );
};

function codeMessage(errorCode: number): string {
  switch (errorCode) {
    case 401:
      return 'No autorizado';
    case 404:
      return 'Recurso no encontrado';
    default:
      return '';
  }
}
